const getSofaBuilderLink = (collectionName, link) => link;

export default getSofaBuilderLink;
